var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-charts-pages"},[_c('div',{ref:"lineCharts",staticClass:"charts"})])
}
var staticRenderFns = []

export { render, staticRenderFns }